var map = {
	"./LOGO_le chai_pp_INSTA_Plan de travail 1.jpg": 3208,
	"./LOGOtransparent.webp": 4113,
	"./barrel.webp": 8586,
	"./cuves.webp": 1092,
	"./grape.webp": 7817,
	"./grapeAfternoon.webp": 1351,
	"./grapeEvening.webp": 4711,
	"./grenache_syrah.webp": 5547,
	"./hand.webp": 2843,
	"./ice.webp": 2009,
	"./land.webp": 6615,
	"./le_blanc.webp": 2864,
	"./mt_r.webp": 8938,
	"./multipleGrape.webp": 4389,
	"./pinot_noir.webp": 6475,
	"./product.png": 5035,
	"./raisinsRouge.webp": 9717,
	"./rose_633.webp": 9014,
	"./samLechai.webp": 7891,
	"./sunset.webp": 1936,
	"./verre.webp": 10,
	"./verres.webp": 8023,
	"./walk.webp": 2327,
	"./workshop.webp": 6455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4082;